import { Ring } from '@blocks/Loading'
import MainContainer from '@blocks/MainContainer'
import InviteController from '@club/customer/api/InviteController'
import { route } from '@helpers'
import useRequestEffect from '@hooks/useRequestEffect'
import useTitle from '@hooks/useTitle'
import useMainTemplate from '@templates/Main/hooks/useMainTemplate'
import React from 'react'
import { useParams } from 'react-router'
import { Redirect } from 'react-router-dom'
import InviteClub from './components/Club'

export default function InvitePage() {
    const { secret } = useParams<{ secret?: string }>()

    if (!secret)
        return <Redirect to={route("club:customer")} />

    useTitle("Group: Invite")
    useMainTemplate({ category: "club" })

    const [club, setClub, status] = useRequestEffect(() => InviteController.show(secret))

    return (
        <MainContainer heading="Invite">
            {status === "processing"
                ? <Ring />
                : <InviteClub club={club} />}
        </MainContainer>
    )
}